'use client'

import React from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import BugsnagPerformance from '@bugsnag/browser-performance'

// ---- Error Monitoring ----
export const bugsnag = Bugsnag.start({
  apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY!,
  plugins: [new BugsnagPluginReact()],
  releaseStage: process.env.NEXT_PUBLIC_BUGSNAG_RELEASE_STAGE || process.env.NODE_ENV,
  appVersion: process.env.NEXT_PUBLIC_BUGSNAG_APP_VERSION,
  onError: (event) => {
    // 既知ノイズ抑止例
    if (/ResizeObserver/.test(event.errors[0]?.errorMessage || '')) {
      event.unhandled = false
      return false
    }
  },
})

// React ErrorBoundary
export const BugsnagErrorBoundary = bugsnag.getPlugin('react')!.createErrorBoundary(React)

// ---- Performance (RUM) ----
BugsnagPerformance.start({
  apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY!,
  releaseStage: process.env.NEXT_PUBLIC_BUGSNAG_RELEASE_STAGE,
  appVersion: process.env.NEXT_PUBLIC_BUGSNAG_APP_VERSION,
})
